var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'customize-form-button',
    _vm.loading && 'customize-form-button-loading',
    _vm.size && `customize-form-button-${_vm.size}`
  ],on:{"click":_vm.onClick}},[(_vm.loading)?_c('loading-icon',{staticClass:"customize-form-button-icon"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }